import type { ClaimUploadsStepData } from '@/types';

const claimUploadsStepData: ClaimUploadsStepData = {
  id: 'claim-uploads-step-section',
  testId: 'claim-uploads-step-section',
  title: 'Upload your supporting evidence',
  description:
    "Please upload all documents and expenses listed below. We'll need to review them as part of assessing your claim.",
  documentInstructions: {
    label:
      "Unable to supply one or more of the above? Or do you have several document types that you've combined into one file? That's OK, please tell us about this below.",
    placeholder:
      'Tell us about your supporting evidence if you need. You can enter up to 500 characters.',
    maxLength: 500,
  },
  incompleteDocumentsDialog: {
    title: 'Not all requested documents have been uploaded.',
    description:
      'You can continue now, however, uploading the remaining documents may help us assess your claim faster.',
  },
};

export default claimUploadsStepData;
